import { render, staticRenderFns } from "./InsurerRatesMarkups.vue?vue&type=template&id=3a5c38d7"
import script from "./InsurerRatesMarkups.vue?vue&type=script&lang=js"
export * from "./InsurerRatesMarkups.vue?vue&type=script&lang=js"
import style0 from "./InsurerRatesMarkups.vue?vue&type=style&index=0&id=3a5c38d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports